import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

import { City } from './city.model';
@Injectable()
export class CityService extends AbstractEntityService {

    protected resourceUrl = 'api/cities';
    private resourceNoAuthUrl = 'api/no-auth/cities';
    private resourceSearchUrl = 'api/_search/cities';
    private resourceSearchNoAuthUrl = 'api/no-auth/_search/cities';
    protected resourceCountUrl = 'api/_search/count/cities';

    constructor(protected http: HttpClient)  { super(http); }

    create(city: City): Observable<City> {
        let copy: City = Object.assign({}, city);
        return this.http.post<City>(this.resourceUrl, copy).map((res: City) => {
            return res;
        });
    }

    update(city: City): Observable<City> {
        let copy: City = Object.assign({}, city);
        return this.http.put<City>(this.resourceUrl, copy).map((res: City) => {
            return res;
        });
    }

    find(id: number): Observable<City> {
        return this.http.get<City>(`${this.resourceUrl}/${id}`).map((res: City) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<City>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<City>>(this.resourceUrl, options);
    }

    queryNoAuth(req?: any): Observable<HttpResponse<City>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<City>>(this.resourceNoAuthUrl, options);
    }

    search(req?: any): Observable<HttpResponse<City[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<City[]>>(this.resourceSearchUrl, options);
    }

    searchNoAuth(req?: any): Observable<HttpResponse<City[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<City[]>>(this.resourceSearchNoAuthUrl, options);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/city/city.service.ts